<mat-card>
  <mat-card-title data-at-zigbee-modal-title>
    <div class="topology__header">
      <span>{{ '+ZIGBEE_TOPOLOGY.TITLE' | translate }}</span>
      <button
        data-at-close-zigbee-topology-modal
        mat-icon-button
        gtm="onClose"
        gtmAction="Close Zigbee Topology Modal"
        gtmCategory="zigbeeTopologyModal"
        (click)="onClose()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card-title>
  <mat-card-content #container>
    <svg #svg>
      <defs>
        <marker id="arrow" markerWidth="10" markerHeight="10" refX="0" refY="3" orient="auto">
          <path d="M0,0 L0,6 L9,3 z" fill="#000000" />
        </marker>
      </defs>
    </svg>
    <div class="topology__content">
      <div class="topology__main-device-context">
        <div class="topology__main-device">
          <app-zigbee-topology-device
            [name]="zigbeeTopologyDeviceData.name"
            [businessName]="mainDeviceBusinessName"
            [gatewayId]="gatewaySerialNumber"
            [lqiTotal]="zigbeeTopologyDeviceData.lqiTotal"
            [rx]="zigbeeTopologyDeviceData.rx"
            [tx]="zigbeeTopologyDeviceData.tx"
            [connectionStatus]="zigbeeTopologyDeviceData.status"
          ></app-zigbee-topology-device>
        </div>

        <div class="topology__child-devices">
          <!-- SELF NESTING STRUCTURE START -->
          <ng-container *ngTemplateOutlet="childDevice; context: zigbeeTopologyDeviceData">
          </ng-container>

          <ng-template #childDevice let-devices="devices">
            <ng-container *ngFor="let childrenDevice of devices">
              <app-zigbee-topology-device
                [class.topology--full-width]="childrenDevice?.devices?.length > 0"
                childDevice
                [name]="childrenDevice.name"
                [businessName]="getDeviceNameByDeviceType(childrenDevice.name)"
                [displayName]="childrenDevice.displayName"
                [roomName]="getDeviceRoomName(childrenDevice.id)"
                [lqiTotal]="childrenDevice.lqiTotal"
                [rx]="childrenDevice.rx"
                [tx]="childrenDevice.tx"
                [deviceDescription]="childrenDevice.deviceDescription"
                [connectionStatus]="childrenDevice.status"
              >
                <ng-container *ngIf="childrenDevice?.devices?.length > 0">
                  <ng-container *ngTemplateOutlet="childDevice; context: childrenDevice">
                  </ng-container>
                </ng-container>
              </app-zigbee-topology-device>
            </ng-container>
          </ng-template>
          <!-- SELF NESTING STRUCTURE END -->
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
